import { Typography } from '@mui/material';

import { Base02TextContainer, Container, IconContainer } from './styled';

import { ReactComponent as CosmostationWalletIcon } from 'src/assets/svg/CosmostationWallet.svg';

export default function DefaultStaking() {
  return (
    <Container>
      <IconContainer>
        <CosmostationWalletIcon />
      </IconContainer>

      <Typography variant="h1">Start Staking DYDX</Typography>

      <Base02TextContainer>
        <Typography variant="h9">Secure the network and earn the staking rewards by staking $DYDX</Typography>
      </Base02TextContainer>
    </Container>
  );
}
